<div (click)="onLoadMoreClicked()" class="row justify-content-center p-2 show-more">
    <div class="col-sm-auto d-flex align-items-center">
        <button class="btn btn-link">{{ text }}</button>
        <i class="material-icons md-18 sk-arrow-down">keyboard_arrow_down</i>
    </div>
</div>